import { render, staticRenderFns } from "./WannaBeFranchisee.vue?vue&type=template&id=4a0bd93b&scoped=true&v=4"
var script = {}
import style0 from "./WannaBeFranchisee.vue?vue&type=style&index=0&id=4a0bd93b&scoped=true&lang=css&v=4"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bd93b",
  null
  
)

export default component.exports